import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';

const blockContents = document.querySelectorAll(
	'.block-accordion-side-image__content'
);

const setBlockContentsTop = () => {
	blockContents.forEach((blockContent) => {
		blockContent.style.removeProperty('--contentTop');
		blockContent.parentElement.classList.remove(
			'block-accordion-side-image__row--flex-start'
		);

		const topPosition =
			blockContent.getBoundingClientRect().top -
			blockContent.parentElement.getBoundingClientRect().top;

		blockContent.style.setProperty(
			'--contentTop',
			`${topPosition / getRemBase()}rem`
		);

		blockContent.parentElement.classList.add(
			'block-accordion-side-image__row--flex-start'
		);
	});
};

if (blockContents.length > 0) {
	setBlockContentsTop();

	window.addEventListener('resize', throttle(setBlockContentsTop, 100));
}
